import React from 'react';

import { useIntl } from '../../util/reactIntl';

import { PrimaryButton, SecondaryButton } from '../Button/Button';

import css from './Navigation.module.css';

function Navigation({
  current,
  total,
  canContinue,
  onPrevious,
  onNext,
}) {
  const intl = useIntl();

  return (
    <div className={css.root}>
      <SecondaryButton
        onClick={onPrevious}
        disabled={current === 0}
      >
        {intl.formatMessage({
          id: 'RiskCalculator.navigation.previous',
        })}
      </SecondaryButton>

      <PrimaryButton
        onClick={onNext}
        disabled={!canContinue}
      >
        {current === total - 1
          ? intl.formatMessage({
              id: 'RiskCalculator.navigation.continue',
            })
          : intl.formatMessage({
              id: 'RiskCalculator.navigation.next',
            })}
      </PrimaryButton>
    </div>
  );
}

export default Navigation;